
import React, { useState, forwardRef, useRef } from 'react';
import {
    DialogContent, DialogTitle, Dialog, Paper, TextField, Box, Grid, Typography, TableCell, TableContainer,
    Table, TableHead, Button, IconButton, TableRow, TableBody, Accordion, AccordionDetails,
} from '@mui/material';
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import EditIcon from '@mui/icons-material/Edit';
import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
// import PurchaseEntryPrint from './PurchaseEntryPrint';
import { BootstrapDialog, BootstrapDialogTitle } from '../reusableComponent/BootstrapDialog'
import { StyledTableCell, StyledTableRow } from '../reusableComponent/StyledTable';
import styles from '.././../styles.module.css';
import Customer_Supplier_PaymentAddTab from './Customer_Supplier_PaymentAddTab';


const Customer_Supplier_PaymentDetails = (props) => {
    const login_details = sessionStorage.getItem('loginUser');
    const userInfo = JSON.parse(login_details);
    const location = useLocation();

    const detailsView = props.details;
    const [open, setOpen] = useState(false)
    const dateConversion = (date) => {
        var today = new Date(date);
        var dd = String(today.getDate()).padStart(2, "0");
        var mm = String(today.getMonth() + 1).padStart(2, "0");
        var yyyy = today.getFullYear();
        const convDate = dd + "/" + mm + "/" + yyyy;
        return convDate;
    };
    const handleClose = (event, reason) => {
        setOpen(false);
    };
    const handleClickOpenPopup = (info) => {
        // setInfo(info);
        setOpen(true);
    };

    var containsSales = location.pathname.includes('/sales/');

    const navigate = useNavigate()
    const backBtn = props.currentTab
    const navigateToAddEdit = (row) => {
        const state = {
            row,
            // invoiceSettingList,
            // docNoFormateAvailable,
            backBtn
        }
        navigate(containsSales === true ? '/sales/add-customer-payment' : '/purchase/add-supplier-payment', { state });
    };

    return (
        <>

            <Paper className='mainContainer' sx={{ boxShadow: 'none' }}>

                <Box>
                    <Grid container spacing={2} sx={{ mb: 2 }}>
                        <Grid item md={10}>
                            <Grid container spacing={2} sx={{ mt: 0 }}>
                                <Grid item xs={2.4}>
                                    <Typography className={`${styles.detail_lable}`}>{location.pathname == '/sales/customer-payment' ? 'Customer Name' : 'Supplier Name'}</Typography>
                                    <Typography className={`${styles.detail_lable}`}>Reference No</Typography>
                                    <Typography className={`${styles.detail_lable}`}>Payment Date</Typography>
                                    <Typography className={`${styles.detail_lable}`}>Amount</Typography>
                                    <Typography className={`${styles.detail_lable}`}>Total Due </Typography>
                                    <Typography className={`${styles.detail_lable}`}>Payment Mode</Typography>
                                    <Typography className={`${styles.detail_lable}`}>Instrument No</Typography>
                                    <Typography className={`${styles.detail_lable}`}>Payment Through</Typography>
                                </Grid>
                                <Grid item xs={0.6}>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                    <Typography className={`${styles.detail_lable}`}>: </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography className={`${styles.erp_lable}`} >{detailsView.CNS_id == null ? '-' : detailsView.CNS_Name}</Typography>
                                    <Typography className={`${styles.erp_lable}`}>{detailsView.paymentReferenceNo}</Typography>
                                    <Typography className={`${styles.erp_lable}`}>{dateConversion(detailsView.payment_date)}</Typography>
                                    <Typography className={`${styles.erp_lable}`}> {parseFloat(detailsView.totalPaidAmt).toFixed(2)}</Typography>
                                    <Typography className={`${styles.erp_lable}`}>{parseFloat(detailsView.totalDue).toFixed(2)}</Typography>
                                    <Typography className={`${styles.erp_lable}`}> {(detailsView.payment_mode)}</Typography>
                                    <Typography className={`${styles.erp_lable}`}>{detailsView.instrumentNo === '' ? '-' : detailsView.instrumentNo}</Typography>
                                    <Typography className={`${styles.erp_lable}`}> {detailsView.bank_id === null ? '-' : detailsView.bankName}</Typography>
                                </Grid>
                                <Grid item md={12} >
                                    <a href={`${detailsView.file_attachment}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        download
                                    >
                                        <Typography className={`${styles.erp_lable}`} style={{ textDecoration: 'underline', display: 'flex', }}> Download Attached File </Typography>
                                    </a>
                                </Grid>
                            </Grid>

                        </Grid>
                        <Grid item md={2}>
                            <Box >
                                <Grid container spacing={0} >
                                    <Grid item md={12} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                                        <Box sx={{ marginBottom: '6px' }}>
                                            <Box sx={{ display: 'flex', justifyContent: 'right', }}>
                                           
                                            <EditIcon style={{  fontSize: '16px', cursor: 'pointer',marginRight: '8px' }}  onClick={() => navigateToAddEdit(detailsView)} />
                                            </Box>
                                            < Box >
                                                <Icon icon="clarity:email-line" width="19" height="19" color="red" style={{}} />
                                            </Box>
                                            {/* < Box>
                                                <ComponentToPrintInvoiceWrapper key={detailsView._id} orderPrint={detailsView} />
                                            </Box> */}
                                            < Box >
                                                {/* <UploadGrn key={detailsView._id} /> */}
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                <TableContainer component={Paper} style={{ overflowY: 'auto', maxHeight: 140 }}>
                    <Table sx={{ minWidth: 700 }} size='small' stickyHeader>
                        <TableHead >
                            <StyledTableRow>
                                <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>Invoice No</StyledTableCell>
                                <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>Invoice Date</StyledTableCell>
                                <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>Due Date</StyledTableCell>
                                <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>Invoice Amount</StyledTableCell>
                                <StyledTableCell align="center" sx={{ fontWeight: "bold" }} className={`${styles.table_head}`}>Paid Amount</StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {JSON.parse(detailsView && detailsView.childRows).map((row, index) => (
                                <>
                                    <StyledTableRow key={row.id} >
                                        <StyledTableCell align="left" className={`${styles.list_table_body}`}>  {row.invoiceNo}</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`}>{dateConversion(row.invoiceDate)}</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`}>{dateConversion(row.dueDate)}</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`}>{parseFloat(row.invoiceAmount).toFixed(2)}</StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`}>{parseFloat(row.amountTopay).toFixed(2)}</StyledTableCell>
                                    </StyledTableRow>
                                </>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <Box style={{marginTop: '12px'}}>
                {(detailsView.remark == '' || detailsView.remark == null || detailsView.remark == undefined) ?
                    <></>
                    :
                    < Typography className={`${styles.detail_lable}`} > <span style={{ fontWeight: 'bold', paddingTop: '10px' }}>Remarks: </span> {detailsView.remark}</Typography>
                }
                </Box>
            </Paper>

        </>
    )
}
export default Customer_Supplier_PaymentDetails;